import {
    calendarGamePath,
    timeFilterSlug,
} from '@app/router/constants/linkConstants';
import { RouteIdentity } from '@app/router/types';

export const LinkPl: RouteIdentity<string> = {
    App: {
        Home: `/${timeFilterSlug}?`,
        Info: '/info',
        Wiki: '/wiki/:pageSlug',
        NotFound: '/404',
        NotAuthorized: '/401',
        TermsAndConditions: '/regulamin',
        CatchAll: '*',
        IdCardVerificationCaptive: '/verify-identity',
        VerifyPhoneCaptive: '/verify-phone',
    },
    Account: {
        Container: '/profil',
        Profile: '', // empty on purpose
        PaymentGatewayStatus: 'static/html/paymentGatewayStatus.html',
        Activate: '/aktywuj-konto',
        PasswordRecovery: '/haslo-przywrocone',
        ForgotPassword: '/zapomniane-haslo',
        Recovery: '/odblokowanie-konta',
        Register: '/rejestracja',
        ResendActivationEmail: '/resendactivationemail',
        ContinueRegistration: '/pamregistrationcontinueregistrationpageurl',
        Deposit: 'wplata',
        History: 'historia/:type?',
        Settings: 'ustawienia',
        Withdrawal: 'wyplata',
        DocumentUpload: 'przesylanie-dokumentow',
        IdentityVerification: 'identity-verification',
        IdentityVerificationUploadAdditional: 'przeslac-dokument',
        ResponsibleGaming: 'odpowiedzialna-gra',
        // eslint-disable-next-line sonarjs/no-duplicate-string
        DepositLimit: '', // not used
        BettingLimit: '', // not used
        LossLimit: '', // not used
        SessionLimit: '', // not used
        SelfExclusion: '', // not used
        TimeOut: '', // not used
        AccountClosure: '', // not used
        RealityCheck: '', // not used
        MyMessages: 'moje-wiadomosci',
        ChangePhone: 'zmiana-numer-telefonu',
        ReferAFriend: 'refer-a-friend',
        HelpAndSupport: 'pomoc-i-wsparcie',
        ChatPlaceholder: 'chat',
        MySocial: 'moj-supersocial',
        EditMySocial: 'edytuj-profil',
        BlockedUsers: 'zablokowani-uzytkownicy',
        MyAccount: 'moje-konto',
        ChangePassword: 'aktualizacja-hasla',
        SettingsBetslip: 'kupon',
        SwitchLanguage: 'zamiana-jezyka',
        SwitchTheme: 'zamiana-motywu',
        LicencePreferences: 'not-used',
        LoginHistory: 'not-used',
        AccountSecurity: 'not-used',
    },
    Sport: {
        OfferEvent: '/offer-event/:eventSlug/',
        PrematchOffer: '/zaklady-bukmacherskie',
        BetSlip: '/betslip',
        Filter: '/filtruj',
        Search: '/wyszukaj',
        Favourites: '/ulubione',
        Category: '/zaklady-bukmacherskie/:sportSlug?/:categorySlug?',
        CategoryPerTime: `/zaklady-bukmacherskie/:sportSlug?/:categorySlug?/${timeFilterSlug}`,
        SportCompetitions: '/zaklady-bukmacherskie/:sportSlug/rozgrywki',
        Competition: `/zaklady-bukmacherskie/:sportSlug/:categorySlug/:tournamentSlug/${timeFilterSlug}?`,
        EventRedirect: '/event/:id(\\d+)',
        TournamentRedirect: '/tournament/:id(\\d+)',
        CategoryRedirect: '/category/:id(\\d+)',
        SuperAdvantage: '/super-przewaga/:sportSlug?',
        PriceBoost: '/super-boost/:sportSlug?',
        MultiEventBetBuilder: '/multi-bet-builder/:sportSlug?',
        PopularBets: '/popular-bets',
        TopWinners: '/topowe-wygrane',
        Social: '/zaklady-bukmacherskie/:sportSlug/social',
    },
    Lottery: {
        Offer: `/zaklady-lottozaklady-lotto/${timeFilterSlug}?`,

    },
    News: {
        Feed: '/newsy',
        Article: '/newsy/:articleSlug',
        Articles: '/artykuly',
    },
    Free2Play: {
        BingoBash: '/bingobash',
        SuperSpin: '/superspin',
        FreeGamesInfo: '/free-games',
        SportCaller: '/supergame',
        SuperMillion: '/supermilion',
        CalendarGame: `/${calendarGamePath}`,
        SuperShot: '/supershot',
        TopManager: '/top-manager',
        FantasticDuels: '/super-starcie',
    },
    GrowthMarketing: {
        LandingIntro: '/intro',
        PromotionsInfo: '/promocje-bonusow',
        NewBettingSiteSerbia: '/nova-kladionica-u-srbiji',
    },
    Native: {
        AppsFooter: '/footerframe',
        Wiki: '/nativewiki/:pageSlug',
    },
    BonusAndComms: {
        LpBonus: '/primulbonus*',
        PromotionHub: '/promocje-i-bonusy',
        Notifications: '/powiadomienia',
        MarketingConsent: 'zgoda-marketingowa',
    },
    Loyalty: {
        Supercoins: '/supercoins',
    },
};
